import React from "react";
import Sidebaradmin from "./Components/Sidebar";
import Navbaradmin from "./Components/navbar";
import OnboardingAnalytics from "./Components/OnboardingAnalytics";
import "./admin.css";

export default function AdminOnboardingAnalyticsPage() {
  return (
    <div className="admin-dashboard admin-onboarding">
      <div className="admin-shell">
        <Sidebaradmin />
        <div className="admin-workspace">
          <Navbaradmin />
          <main className="admin-main">
            <OnboardingAnalytics />
            <footer className="admin-page-footer"><span>PrepNexis admin console</span><span>Better starts. Better learning.</span></footer>
          </main>
        </div>
      </div>
    </div>
  );
}
